<template v-if="singleArticle">
    <div class="single-post">
        <div class="single-post__banner"
            :style="{ backgroundImage: `url(` + getPathFromMedia + singleArticle.image.url + `)` }" v-if="singleArticle.image">
            <div class="text-center">
                <v-row>
                    <v-col cols="12" class="justify-center align-center d-flex py-0">
                        <h1>{{ singleArticle.title }}</h1>
                    </v-col>
                    <v-col cols="12">
                        <ul class="justify-center align-center d-flex post-categories__rows">
                            <li v-for="category in singleArticle.categories" :key="category.id">{{ category.title
                            }}<span>&nbsp;//&nbsp; </span></li>
                        </ul>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <ul class="justify-center align-center d-flex post-data__rows">
                            <li v-if="singleArticle.author"><span><svg width="16" height="19" viewBox="0 0 16 19"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.875 9.25C10.3359 9.25 12.375 7.24609 12.375 4.75C12.375 2.28906 10.3359 0.25 7.875 0.25C5.37891 0.25 3.375 2.28906 3.375 4.75C3.375 7.24609 5.37891 9.25 7.875 9.25ZM11.0039 10.375H10.4062C9.63281 10.7617 8.78906 10.9375 7.875 10.9375C6.96094 10.9375 6.08203 10.7617 5.30859 10.375H4.71094C2.10938 10.375 0 12.5195 0 15.1211V16.5625C0 17.5117 0.738281 18.25 1.6875 18.25H14.0625C14.9766 18.25 15.75 17.5117 15.75 16.5625V15.1211C15.75 12.5195 13.6055 10.375 11.0039 10.375Z"
                                            fill="white" />
                                    </svg></span>{{ singleArticle.author.name }}</li>
                            <li><span><svg width="16" height="19" viewBox="0 0 16 19" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.20312 10.375C5.41406 10.375 5.625 10.1992 5.625 9.95312V8.54688C5.625 8.33594 5.41406 8.125 5.20312 8.125H3.79688C3.55078 8.125 3.375 8.33594 3.375 8.54688V9.95312C3.375 10.1992 3.55078 10.375 3.79688 10.375H5.20312ZM9 9.95312V8.54688C9 8.33594 8.78906 8.125 8.57812 8.125H7.17188C6.92578 8.125 6.75 8.33594 6.75 8.54688V9.95312C6.75 10.1992 6.92578 10.375 7.17188 10.375H8.57812C8.78906 10.375 9 10.1992 9 9.95312ZM12.375 9.95312V8.54688C12.375 8.33594 12.1641 8.125 11.9531 8.125H10.5469C10.3008 8.125 10.125 8.33594 10.125 8.54688V9.95312C10.125 10.1992 10.3008 10.375 10.5469 10.375H11.9531C12.1641 10.375 12.375 10.1992 12.375 9.95312ZM9 13.3281V11.9219C9 11.7109 8.78906 11.5 8.57812 11.5H7.17188C6.92578 11.5 6.75 11.7109 6.75 11.9219V13.3281C6.75 13.5742 6.92578 13.75 7.17188 13.75H8.57812C8.78906 13.75 9 13.5742 9 13.3281ZM5.625 13.3281V11.9219C5.625 11.7109 5.41406 11.5 5.20312 11.5H3.79688C3.55078 11.5 3.375 11.7109 3.375 11.9219V13.3281C3.375 13.5742 3.55078 13.75 3.79688 13.75H5.20312C5.41406 13.75 5.625 13.5742 5.625 13.3281ZM12.375 13.3281V11.9219C12.375 11.7109 12.1641 11.5 11.9531 11.5H10.5469C10.3008 11.5 10.125 11.7109 10.125 11.9219V13.3281C10.125 13.5742 10.3008 13.75 10.5469 13.75H11.9531C12.1641 13.75 12.375 13.5742 12.375 13.3281ZM15.75 4.1875C15.75 3.27344 14.9766 2.5 14.0625 2.5H12.375V0.671875C12.375 0.460938 12.1641 0.25 11.9531 0.25H10.5469C10.3008 0.25 10.125 0.460938 10.125 0.671875V2.5H5.625V0.671875C5.625 0.460938 5.41406 0.25 5.20312 0.25H3.79688C3.55078 0.25 3.375 0.460938 3.375 0.671875V2.5H1.6875C0.738281 2.5 0 3.27344 0 4.1875V16.5625C0 17.5117 0.738281 18.25 1.6875 18.25H14.0625C14.9766 18.25 15.75 17.5117 15.75 16.5625V4.1875ZM14.0625 16.3516C14.0625 16.4922 13.957 16.5625 13.8516 16.5625H1.89844C1.75781 16.5625 1.6875 16.4922 1.6875 16.3516V5.875H14.0625V16.3516Z"
                                            fill="white" />
                                    </svg></span>{{ getNewDateFormat }}</li>
                            <li v-if="singleArticle.readingTime"><span><svg width="18" height="18" viewBox="0 0 18 18"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 0.53125C4.18359 0.53125 0.28125 4.43359 0.28125 9.25C0.28125 14.0664 4.18359 17.9688 9 17.9688C13.8164 17.9688 17.7188 14.0664 17.7188 9.25C17.7188 4.43359 13.8164 0.53125 9 0.53125ZM12.2344 11.5352L11.5312 12.4141C11.4258 12.5547 11.25 12.6602 11.0742 12.6602C10.9688 12.6602 10.8281 12.5898 10.7578 12.5195L8.40234 10.7617C8.08594 10.5508 7.875 10.0586 7.875 9.67188V4.1875C7.875 3.90625 8.12109 3.625 8.4375 3.625H9.5625C9.84375 3.625 10.125 3.90625 10.125 4.1875V9.25L12.1641 10.7617C12.2695 10.8672 12.375 11.043 12.375 11.1836C12.375 11.3242 12.3047 11.4648 12.2344 11.5352Z"
                                            fill="white" />
                                    </svg></span>{{ singleArticle.readingTime }}-Minute Read Time</li>
                        </ul>
                    </v-col>
                </v-row>
            </div>
        </div>
        <v-row class="pb-md-12 pb-8 mt-12">
            <div class="content text-content" v-if="singleArticle.content" 
                v-html="singleArticle.content.replace('![Image.jpg](','').replace('.jpg)', '.jpg\'>').replace('.png)', '.png\'>').replace('/uploads', '<img src=\'' + getPathFromMedia + '/uploads')">
            </div>
        </v-row>
        <v-row class="pb-md-5 card-cta__block" v-if="singleArticle.block_cta_post">
            <div class="content card-cta__wrap text-center mb-12 pb-5">
                <v-col cols="12" class="pt-12 mt-md-12">
                    <h2 v-if="singleArticle.block_cta_post.title">{{ singleArticle.block_cta_post.title}}</h2>
                </v-col>
                <v-col cols="12 mb-3">
                    <p v-if="singleArticle.block_cta_post.description" v-html="singleArticle.block_cta_post.description"></p>
                </v-col>
                <v-col cols="12" class="pb-8 mb-md-12">
                    <v-btn @click="openSignUp" depressed color="primary" class="cta__main-btn">{{
                    singleArticle.block_cta_post.titleButton }}
                    </v-btn>

                </v-col>
            </div>
        </v-row>
        <v-row class="post-author__wrap py-5 py-md-12" v-if="singleArticle.author">
            <div class="content">
                <v-card class="mx-auto px-5 pb-5 my-12 card-author" max-width="900">
                    <v-row class="pt-0">
                        <v-col cols="12" md="3" class="athor-title align-center d-flex flex-column pt-0 pb-md-8">
                            <div class="author-badge  mb-7 mt-3">
                                AUTHOR BIO
                            </div>
                            <v-avatar size="130px">
                                <img alt="Avatar" :src="getPathFromMedia + postAuthor.photo.url" v-if="postAuthor.photo">
                            </v-avatar>
                            <h4 class="mt-1">{{ singleArticle.author.name }}</h4>
                            <p>{{ singleArticle.author.title }}</p>
                            <ul class="justify-center align-center d-flex author-social mt-3 pl-0">
                                <li v-if="singleArticle.author.facebook"><a :href="singleArticle.author.facebook"
                                        target="_blank"><svg width="10" height="17" viewBox="0 0 10 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.71875 9.25L9.15625 6.375H6.375V4.5C6.375 3.6875 6.75 2.9375 8 2.9375H9.28125V0.46875C9.28125 0.46875 8.125 0.25 7.03125 0.25C4.75 0.25 3.25 1.65625 3.25 4.15625V6.375H0.6875V9.25H3.25V16.25H6.375V9.25H8.71875Z" />
                                        </svg></a></li>
                                <li v-if="singleArticle.author.instagram"><a :href="singleArticle.author.instagram"
                                        target="_blank"><svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7.33331 3.65625C5.33331 3.65625 3.73956 5.28125 3.73956 7.25C3.73956 9.25 5.33331 10.8438 7.33331 10.8438C9.30206 10.8438 10.9271 9.25 10.9271 7.25C10.9271 5.28125 9.30206 3.65625 7.33331 3.65625ZM7.33331 9.59375C6.05206 9.59375 4.98956 8.5625 4.98956 7.25C4.98956 5.96875 6.02081 4.9375 7.33331 4.9375C8.61456 4.9375 9.64581 5.96875 9.64581 7.25C9.64581 8.5625 8.61456 9.59375 7.33331 9.59375ZM11.8958 3.53125C11.8958 3.0625 11.5208 2.6875 11.0521 2.6875C10.5833 2.6875 10.2083 3.0625 10.2083 3.53125C10.2083 4 10.5833 4.375 11.0521 4.375C11.5208 4.375 11.8958 4 11.8958 3.53125ZM14.2708 4.375C14.2083 3.25 13.9583 2.25 13.1458 1.4375C12.3333 0.625 11.3333 0.375 10.2083 0.3125C9.05206 0.25 5.58331 0.25 4.42706 0.3125C3.30206 0.375 2.33331 0.625 1.48956 1.4375C0.677063 2.25 0.427063 3.25 0.364563 4.375C0.302063 5.53125 0.302063 9 0.364563 10.1562C0.427063 11.2812 0.677063 12.25 1.48956 13.0938C2.33331 13.9062 3.30206 14.1562 4.42706 14.2188C5.58331 14.2812 9.05206 14.2812 10.2083 14.2188C11.3333 14.1562 12.3333 13.9062 13.1458 13.0938C13.9583 12.25 14.2083 11.2812 14.2708 10.1562C14.3333 9 14.3333 5.53125 14.2708 4.375ZM12.7708 11.375C12.5521 12 12.0521 12.4688 11.4583 12.7188C10.5208 13.0938 8.33331 13 7.33331 13C6.30206 13 4.11456 13.0938 3.20831 12.7188C2.58331 12.4688 2.11456 12 1.86456 11.375C1.48956 10.4688 1.58331 8.28125 1.58331 7.25C1.58331 6.25 1.48956 4.0625 1.86456 3.125C2.11456 2.53125 2.58331 2.0625 3.20831 1.8125C4.11456 1.4375 6.30206 1.53125 7.33331 1.53125C8.33331 1.53125 10.5208 1.4375 11.4583 1.8125C12.0521 2.03125 12.5208 2.53125 12.7708 3.125C13.1458 4.0625 13.0521 6.25 13.0521 7.25C13.0521 8.28125 13.1458 10.4688 12.7708 11.375Z" />
                                        </svg></a></li>
                                <li v-if="singleArticle.author.twitter"><a :href="singleArticle.author.twitter"
                                        target="_blank"><svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.6667 0.25H1.63544C1.10419 0.25 0.666687 0.71875 0.666687 1.28125V13.25C0.666687 13.8125 1.10419 14.25 1.63544 14.25H13.6667C14.1979 14.25 14.6667 13.8125 14.6667 13.25V1.28125C14.6667 0.71875 14.1979 0.25 13.6667 0.25ZM4.88544 12.25H2.82294V5.59375H4.88544V12.25ZM3.85419 4.65625C3.16669 4.65625 2.63544 4.125 2.63544 3.46875C2.63544 2.8125 3.16669 2.25 3.85419 2.25C4.51044 2.25 5.04169 2.8125 5.04169 3.46875C5.04169 4.125 4.51044 4.65625 3.85419 4.65625ZM12.6667 12.25H10.5729V9C10.5729 8.25 10.5729 7.25 9.51044 7.25C8.41669 7.25 8.26044 8.09375 8.26044 8.96875V12.25H6.19794V5.59375H8.16669V6.5H8.19794C8.47919 5.96875 9.16669 5.40625 10.1667 5.40625C12.2604 5.40625 12.6667 6.8125 12.6667 8.59375V12.25Z" />
                                        </svg>
                                    </a></li>
                                <li v-if="singleArticle.author.linkedIn"><a :href="singleArticle.author.linkedIn"
                                        target="_blank"><svg width="16" height="14" viewBox="0 0 16 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M14.3438 4C14.9688 3.53125 15.5312 2.96875 15.9688 2.3125C15.4062 2.5625 14.75 2.75 14.0938 2.8125C14.7812 2.40625 15.2812 1.78125 15.5312 1C14.9062 1.375 14.1875 1.65625 13.4688 1.8125C12.8438 1.15625 12 0.78125 11.0625 0.78125C9.25 0.78125 7.78125 2.25 7.78125 4.0625C7.78125 4.3125 7.8125 4.5625 7.875 4.8125C5.15625 4.65625 2.71875 3.34375 1.09375 1.375C0.8125 1.84375 0.65625 2.40625 0.65625 3.03125C0.65625 4.15625 1.21875 5.15625 2.125 5.75C1.59375 5.71875 1.0625 5.59375 0.625 5.34375V5.375C0.625 6.96875 1.75 8.28125 3.25 8.59375C3 8.65625 2.6875 8.71875 2.40625 8.71875C2.1875 8.71875 2 8.6875 1.78125 8.65625C2.1875 9.96875 3.40625 10.9062 4.84375 10.9375C3.71875 11.8125 2.3125 12.3438 0.78125 12.3438C0.5 12.3438 0.25 12.3125 0 12.2812C1.4375 13.2188 3.15625 13.75 5.03125 13.75C11.0625 13.75 14.3438 8.78125 14.3438 4.4375C14.3438 4.28125 14.3438 4.15625 14.3438 4Z" />
                                        </svg>
                                    </a></li>
                            </ul>
                        </v-col>
                        <v-col cols="12" md="9" class="author-description pb-9 my-auto py-md-12" v-html="singleArticle.author.bio">
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </v-row>
        <div class="content px-4 related-articles__block mb-12 mt-8" v-if="relatedArticles">
            <v-row>
                <v-col class="text-center mt-8 mt-md-12 pb-4">
                    <h2>Related Articles</h2>
                </v-col>
            </v-row>
            <div class="blog-content-wrap">              
                <div class="mb-10 mt-3 card-wrap d-grid">
                        <ItemCardPost v-for="post in relatedArticles" :key="post.slug" :post="post"></ItemCardPost>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemCardPost from "@/components/ItemCardPost.vue";
import SiteService from "../services/site.service";
import { flattenObj } from "@/utils/utils";

export default {
    components: { ItemCardPost },
    metaInfo: function () {
        return {
            title: this.metaTitle,     
            meta: [
                { name: 'description', content: this.metaDescription },
                {
                    keyName: this.keywords
                }
            ]
        }
    },
    data () {
        return {
            metaTitle: '',
            metaDescription: '',
            keywords: '',
            allArticle: [],
            arrCategoryPost: [],
            allAuthors: [],
            postAuthor: [],
            relatedArticles: [],
            singleArticle: {},
            arrMonth: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'November',
                'December',
            ],
            getPathFromMedia: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com'
        }
    },
    computed: {
       getNewDateFormat () {
            return this.arrMonth[new Date(this.singleArticle.createdAt).getMonth()] + ' ' + new
                Date(this.singleArticle.createdAt).getDate() + ', ' + new
                    Date(this.singleArticle.createdAt).getFullYear();
       },
    },
    methods: {
        openSignUp() {
            this.$store.dispatch('setSignUpModal', true);
            const options = {
                method: 'POST',
                headers: { accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    data: '{"token": "TAEE6J", "event": "`Register` Nav Link", "customer_properties": {"$email": "edurent@klaviyo.com"}}'
                })
            };

            fetch('https://a.klaviyo.com/api/track', options)
                .then(response => response.json());

        },
        async fetchPostsAndAuthors() {
            const response = await SiteService.getPosts();
            const authors = await SiteService.getAuthors();
            this.allArticle = flattenObj(response);
            this.allAuthors = flattenObj(authors);

            this.allArticle.map(article => {
                if (article.slug == this.$route.params.slug) {
                    this.singleArticle = article;
                    // eslint-disable-next-line for-direction
                    for (let j = 0; j < this.singleArticle.categories.length; j++) {
                        this.arrCategoryPost.push(this.singleArticle.categories[j].title);
                    }
                }
            });

            this.metaTitle = this.singleArticle.metaTitle;
            this.metaDescription = this.singleArticle.metaTitle;
            this.keywords = this.singleArticle.keywords;

            this.allAuthors.filter(author => {
                if (this.singleArticle.author && author.id == this.singleArticle.author.id) {
                    this.postAuthor = author;
                }
            });

            let countArticles = 0;
         
            this.relatedArticles = this.allArticle.filter(article => {

                for (let i = 0; i < article.categories.length; i++) {
                    
                    if (this.arrCategoryPost.includes(article.categories[i].title) && countArticles < 3) {
                        
                        if (!this.relatedArticles.includes(article) && article != this.singleArticle) {
                            
                            countArticles++;
                            //.relatedArticles.push(article);
                            return article;
                        }
                    } 
                    if (countArticles >= 3) {                   
                        continue;
                    }                   
                } 
                  
            
            });           
        }
       
    },
    beforeMount() {
        this.fetchPostsAndAuthors();
    },
    watch: {
        '$route.params.slug': {
            immediate: true,
            handler() {
                
                this.fetchPostsAndAuthors();
            },
        },
    },
}
</script>
<style>
.text-content img {
        width: 100%;
        margin: 6% auto 0;
        border-radius: 10px;
    }
    .card-wrap:hover {
        cursor: pointer;
    }
    .author-badge {
        margin-left: 5%;
        height: 36px;
        width: 130px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 11px;
        line-height: 30px;
        text-transform: uppercase;
        /* #2D76E3 */
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #2D76E3;
        border-radius: 0px 0px 10px 10px;
    }
    .card-author.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        overflow: hidden;
    }
    .post-author__wrap {
        background: #F6F8FA;
        width: 100%;
    }
    div.single-post {
        display: flex;
        flex-direction: column;
    }
    .card-cta__block {
        width: 92%;
        margin-left: auto;
        margin-right: auto;
    }
    div.single-post .card-cta__block .col h2 {
        font-size: 30px;
    }
    div.single-post .content.text-content ul,
    div.single-post .content.text-content p {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        max-width: 736px;
        margin: 3% auto;
    }
    div.single-post .content.text-content ul {
        padding-left: 8%;
        margin: 2% auto 0;
    }
    div.single-post .content.text-content ul li {
        line-height: 1.75;
    }
    div.single-post .content.text-content ul li::marker {
        color: #2D76E3;
        font-size: 1.2em;
    }
    div.single-post .content.text-content h3,
    div.single-post .content.text-content h4,
    div.single-post .content.text-content h2 {
        max-width: 736px;
        margin: auto;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        line-height: 1.5;
        margin-bottom: -.5%;
        margin-top: 5%;       
    }
    div.single-post .content.text-content h2 {
        margin-bottom: -2%;
    }
    .athor-title h4 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 30px;
        /* identical to box height, or 167% */
        margin-bottom: 0;
        color: #272629;
    }
    .athor-title p {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12.8px;
        line-height: 19px;
        /* identical to box height, or 150% */

        text-align: center;

        color: #727880;
    }
    div.single-post .content.text-content h2 {
        font-size: 30px;
    }
    div.single-post .content.text-content h4,
    div.single-post .content.text-content h3 {
        font-size: 20px;
    }
    div.single-post .content.text-content blockquote {
        max-width: 811px;
        margin: 7% auto;
        background: #7BB0FF;
        border-radius: 10px;
        color: #fff;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 26px;
        line-height: 1.35;
        padding: 5% 3% 5% 16%;
        position: relative;        
    }
    blockquote:after {
        position: absolute;
        content: '';
        top: calc(50% - 30px);
        left: 5%;
        width: 68px;
        height: 59px;
        background-image: url("../../src/assets/media/blockquote.svg");
        background-size: cover;
    }
    div.single-post .author-social,
    .post-data__rows,
    .post-categories__rows {
        list-style: none;
        z-index: 10;
    }
    .post-data__rows {
        margin: auto;
    }
    div.single-post .author-social li {
        padding: 0 10px;
    }
    div.single-post .author-social li > a > svg {
        fill: #272629;
        transition-duration: .4s;
    }
    div.single-post .author-social li>a:hover >svg {
        fill: #2D76E3;
    }
    .author-title h4 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 30px;
        color: #272629;
    }
    .author-title p {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12.8px;
        line-height: 19px;
        /* identical to box height, or 150% */

        text-align: center;

        color: #727880;
    }
    div.single-post .author-description {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        color: #727880;
        max-width: 636px;
    }
    div.single-post .author-description p {
        line-height: 1.6;
    }
    .post-data__rows li {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 30px;
        color: #FFFFFF;
        z-index: 10;
        display: inline-flex;
        align-items: center;
        margin: 0 10px;
    }
    .post-data__rows li svg {
        height: 27px;
    }
    .post-data__rows li span {
        padding-right: 10px;
         height: 27px;
    }
    .post-categories__rows li {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 27px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        z-index: 10;
        color: #7BB0FF;
    }
    .post-categories__rows li:last-child span {
        display: none;
    }
    .related-articles__block h2 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 30px;
        line-height: 45px;
    }
    .single-post .content.related-articles__block {
        max-width: 1480px;
    }
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 15px;
        padding: 0;
        min-width: 0;
        justify-content: space-between;
        flex-direction: column;
        display: flex;
        transition-delay: .4s;
        overflow: hidden;

    }
    .card-post.v-card:hover {
        box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)!important;
    }
    .card-post .v-image {
        max-height: 307px;
    }
    .card-post  h2 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 40px;
    }
    .card-post .read-more span {
        color: #2850E9;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        text-transform: capitalize;
        letter-spacing: normal;
    }
    .card-post .read-more:hover:before {
        display: none;
    }
    .v-card__text {
        height: calc(100% - 56px);
    }
    .card-post .v-card__actions  {
        height: 56px;
    }
    .card-post .v-card__actions > .v-btn.v-btn.read-more  {
        padding: 0;
        height: auto;
    }
    .card-post .v-card__actions > .v-btn.v-btn.read-more span,
    .card-post .read-more:active,
    .card-post .read-more:focus,
    .card-post .read-more:hover {
        background: #fff;
    }
    .card-text-wrap {
        flex-direction: column;
    }
    .card-text-wrap {
        justify-content: space-between;
        flex-direction: column;
    }
    .single-post {
        margin-top: 64px;
    }
    .single-post__banner {
        padding-top: 140px;
        margin-top: -64px;
        display: block;
        min-height: 500px;        
        background-position: center center;
        background-size: cover;
        width: 100vw;
        height: auto;
        position: relative;
        border-bottom: 7px solid #2D76E3;
    }
    .card-cta__wrap {
        background-image: url("../../src/assets/media/card-cta.jpg");            
        background-position: center center;
        background-size: cover;
        width: 100vw;
        height: auto;
        position: relative;
        border-radius: 10px;
        color: #fff;
        overflow: hidden;
        border: 3px solid #2D76E3;
    }
    .card-cta__wrap .col {
        z-index: 2;
        display: flex;
        justify-content: center;
    }
    .card-cta__wrap .col p {
        max-width: 577px;
    }
    .card-cta__wrap .col p,
    .card-cta__wrap .col h2,
    .card-cta__wrap .col a.v-btn {
        z-index: 2;
    }
    .card-cta__wrap p a {
        font-weight: 500;
        transition-duration: .4s;
    }
    .card-cta__wrap p a:hover {
        text-decoration: underline!important;
    }
    .v-btn:not(.v-btn--round).v-size--default.cta__main-btn {
        height: 64px;
        min-width: 276.92px;
        background: #2D76E3;
        border-radius: 10px;
        z-index: 5;
    }
    .card-cta__wrap .col .v-btn .v-btn__content {
        text-transform: capitalize;
        color: #fff;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: normal;
    }
    .card-cta__wrap:before,
    div.single-post__banner:before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(39, 38, 41, 0.8);
        z-index: 1;
    }
    div.single-post__banner h1 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: clamp(26px, 2.5888888889vw, 48px);
        line-height: 1.5;
        /* identical to box height, or 150% */

        text-align: center;
        color: #FFFFFF;
        z-index: 2;
        max-width: 1200px;
    }
    .blog-content-wrap .d-grid {
        grid-gap: 50px;
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
    }
    .single-post .content {
        max-width: 900px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .single-post .content.text-content p {
       margin: 7% auto;
    }
    .single-post .content.text-content figure {
        max-width: 100%;
        width: 100%;
    }
    .single-post .content figure img {
        margin-bottom: 1rem;
        max-width: 100%;
        border-radius: 10px;
        
    }
    .single-post .content figcaption {        
        color: #727880;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12.8px;
        line-height: 19px;
        text-align: left;
        position: relative;
        padding-left: 20px;
        margin: 0;
        margin-bottom: 3%;
        display: inline-block;
    }
    .single-post .content figcaption:after {
        position: absolute;
        content: '';
        width: 4px;
        height: 100%;
        background-color: #2D76E3;
        top: 0;
        left: -0;
    }
    @media screen and (max-width: 1600px) {
        .blog-content-wrap .d-grid {
            grid-gap: clamp(30px, 1.3888888889vw, 50px);
        }
        .card-post h2 {
            line-height: 1.3;
        }
        div.single-post {
            min-height: 450px;
        }
    }
    @media screen and (max-width: 900px) {
        .single-post__banner {
            min-height: 400px;
            padding-top: 0;
            display: flex;
            align-items: center;
        }

        .single-post .content.text-content figure {
            width: 90%;
            margin: auto;
        }
        .blog-content-wrap .d-grid {
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
        }
        .blog-content-wrap .d-grid > div {
            max-width: 45%;
        }
        div.single-post h1 {
            max-width: 90%;
        }
        .blog-content-wrap .d-grid {
            grid-template-columns: 1fr 1fr;
        }
        .card-post .v-image {
            max-height: 200px;
        }
        div.single-post h1 {
            padding-top: 0;
        }
        div.single-post {
            min-height: 350px;
            padding-top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        div.post-author__wrap .content,
        blockquote,
        .content.text-content h3,
        div.single-post .content.text-content h4,
        div.single-post .content.text-content h2,
        div.single-post .content.text-content ul,
        div.single-post .content.text-content p {
            width: 90%;
        }
        blockquote {
            font-size: 20px;
            line-height: 1.53;
        }
        .v-btn:not(.v-btn--round).v-size--default.cta__main-btn {
            min-height: 45px!;
            min-width: 250px;
        }
        div.single-post .content.text-content blockquote:after {
            top: calc(50% - 20px);
            width: 40px;
            height: 35px;
        }
        div.single-post .content.text-content h2 {
            font-size: 26px;
            line-height: 1.3;
            margin-bottom: 1rem;
        }
        div.single-post .content.text-content h3,
        div.single-post .content.text-content h4 {
             margin-top: 2rem;
             margin-bottom: 1rem;
        }
        .post-categories__rows,
        .post-data__rows {
            flex-wrap: wrap;
            width: 90%;
        }
        div.single-post .card-cta__block .col h2 {
            font-size: 26px;
        }
    }
    @media screen and (max-width: 650px) {
        .blog-content-wrap .d-grid {
            grid-template-columns: 1fr;
        }
        div.single-post .content.text-content blockquote {
            padding: 2rem 2rem 2rem calc(70px + 3%);
        }
        .blog-content-wrap .d-grid > div {
            max-width: 90%;
        }
        .blog-content-wrap {
            max-width: 400px;
            margin: auto;
        }
        div.single-post {
            min-height: 250px;
        }
        div.single-post h1 {
            padding-bottom: 1rem;
        }
        div.single-post .content.text-content blockquote {
            font-size: 16px;
        }
        .card-cta__block {
            max-width: 100%;
            width: calc(100% - 35px);
        }
        div.single-post .content.text-content blockquote,
        div.single-post .content.text-content h3,
        div.single-post .content.text-content h4,
        div.single-post .content.text-content h2,
        div.single-post .content.text-content ul,
        div.single-post .content.text-content p,
        .single-post .content.text-content figure {
            width: calc(100% - 60px);
        }
        div.post-author__wrap .content {
            width: calc(100% - 40px);
        }
        .single-post .content.text-content figure {
            margin: auto;
        }
        .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
            width: 100%;
            max-width: 100%;
        }
    }
</style>